// 이번 달 보호자 알림이 못 간 집 목록 — 배송은 기록됐지만 문자가 실패한 건을 사장님이 알고 번호를 고칠 수 있게 한다
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getDocs, where } from "firebase/firestore";
import { orgQuery } from "@/lib/org";
import { fmtYearMonth } from "@/lib/format";
import { plainNotifyReason } from "@/lib/notifyReason";

interface Row { id: string; school: string; name: string; reason: string; }


export default function NotifyFailures() {
  const [rows, setRows] = useState<Row[] | null>(null);
  const [showAll, setShowAll] = useState(false);
  useEffect(() => {
    getDocs(orgQuery("deliveries", where("yearMonth", "==", fmtYearMonth()), where("notifyOk", "==", false)))
      .then((snap) => setRows(snap.docs.map((d) => {
        const x = d.data() as { school?: string; studentName?: string; notifyReason?: string };
        return { id: d.id, school: x.school || "", name: x.studentName || "", reason: plainNotifyReason(x.notifyReason || "") };
      })))
      .catch(() => setRows([]));
  }, []);

  if (!rows || rows.length === 0) return null;
  return (
    <div className="card p-4 border border-amber-200 bg-amber-50">
      <div className="font-bold text-amber-800">📵 이번 달 보호자 알림이 못 간 집 {rows.length}곳</div>
      <p className="text-sm text-amber-700 mt-1">배송 기록은 남아 있습니다. 번호를 고치면 다음 배송부터 알림이 갑니다.</p>
      <ul className="mt-2 text-sm divide-y divide-amber-200">
        {(showAll ? rows : rows.slice(0, 8)).map((r) => (
          <li key={r.id} className="py-2 flex justify-between gap-3 flex-wrap">
            <span><b>{r.school} {r.name}</b> — {r.reason}</span>
            <Link className="underline text-amber-800" to={`/admin/students?q=${encodeURIComponent(r.name)}`}>번호 고치기</Link>
          </li>
        ))}
      </ul>
      {rows.length > 8 && !showAll && <button className="text-sm underline text-amber-800 mt-1 min-h-[36px]" onClick={() => setShowAll(true)}>외 {rows.length - 8}곳 모두 보기</button>}
    </div>
  );
}
